// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1595":"16617e36","4156":"af72bec7","6234":"4d7f6337","7028":"af72bec7"}[chunkId] + ".chunk.css";
};